export interface ArticleMeta {
  slug: string;
  prefix: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'usfans-spreadsheet',
    prefix: 'a1',
    image:
      'https://readdy.ai/api/search-image?query=A%20clean%20minimal%20workspace%20scene%20with%20an%20open%20laptop%20showing%20a%20colorful%20spreadsheet%20and%20a%20few%20folded%20streetwear%20garments%20beside%20it%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20window%20light%2C%20fresh%20editorial%20style%2C%20high%20detail%2C%20airy%20organized%20composition&width=800&height=450&seq=usfans-art-01&orientation=landscape',
  },
  {
    slug: 'usfans-creator-directory',
    prefix: 'a2',
    image:
      'https://readdy.ai/api/search-image?query=A%20neat%20grid%20of%20abstract%20profile%20cards%20with%20avatars%20and%20labels%20arranged%20on%20a%20soft%20cream%20background%20representing%20a%20directory%2C%20soft%20diffused%20lighting%2C%20modern%20editorial%20graphic%20style%2C%20high%20detail%2C%20clean%20organized%20layout%20composition&width=800&height=450&seq=usfans-art-02&orientation=landscape',
  },
  {
    slug: 'usfans-review',
    prefix: 'a3',
    image:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20magnifying%20glass%20resting%20over%20a%20folded%20streetwear%20t%20shirt%20with%20five%20small%20gold%20star%20ratings%20floating%20nearby%20on%20a%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20review%20concept%20photography%2C%20high%20detail%2C%20clean%20minimal%20composition&width=800&height=450&seq=usfans-art-03&orientation=landscape',
  },
  {
    slug: 'usfans-shipping-cost',
    prefix: 'a4',
    image:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20cardboard%20shipping%20boxes%20with%20brown%20packing%20tape%20on%20a%20light%20grey%20floor%20near%20a%20soft%20window%2C%20gentle%20daylight%2C%20logistics%20delivery%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20airy%20composition&width=800&height=450&seq=usfans-art-04&orientation=landscape',
  },
  {
    slug: 'usfans-coupon',
    prefix: 'a5',
    image:
      'https://readdy.ai/api/search-image?query=A%20collection%20of%20gift%20cards%20discount%20tags%20and%20a%20small%20wrapped%20present%20with%20a%20red%20ribbon%20arranged%20on%20a%20warm%20sand%20background%2C%20soft%20natural%20lighting%2C%20savings%20and%20promotion%20concept%20photography%2C%20editorial%20flat%20lay%2C%20high%20detail%2C%20clean%20balanced%20composition&width=800&height=450&seq=usfans-art-05&orientation=landscape',
  },
  {
    slug: 'usfans-warehouse',
    prefix: 'a6',
    image:
      'https://readdy.ai/api/search-image?query=Tall%20industrial%20shelving%20units%20filled%20with%20neatly%20organized%20cardboard%20boxes%20inside%20a%20bright%20modern%20warehouse%2C%20soft%20overhead%20lighting%2C%20logistics%20and%20storage%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20wide%20composition&width=800&height=450&seq=usfans-art-06&orientation=landscape',
  },
  {
    slug: 'usfans-legit',
    prefix: 'a7',
    image:
      'https://readdy.ai/api/search-image?query=A%20large%20green%20checkmark%20shield%20icon%20floating%20above%20a%20folded%20stack%20of%20clothing%20items%20on%20a%20soft%20light%20mint%20background%2C%20soft%20studio%20lighting%2C%20trust%20and%20verification%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20minimal%20composition&width=800&height=450&seq=usfans-art-07&orientation=landscape',
  },
  {
    slug: 'usfans-safety',
    prefix: 'a8',
    image:
      'https://readdy.ai/api/search-image?query=A%20gold%20padlock%20and%20a%20small%20shield%20badge%20placed%20beside%20a%20laptop%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20online%20safety%20and%20security%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20reassuring%20composition&width=800&height=450&seq=usfans-art-08&orientation=landscape',
  },
  {
    slug: 'usfans-find-creators',
    prefix: 'a9',
    image:
      'https://readdy.ai/api/search-image?query=A%20laptop%20screen%20showing%20a%20clean%20search%20interface%20with%20a%20magnifying%20glass%20and%20list%20of%20result%20cards%20on%20a%20warm%20wooden%20desk%20with%20a%20coffee%20cup%20nearby%2C%20soft%20daylight%2C%20discovery%20and%20search%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20composition&width=800&height=450&seq=usfans-art-09&orientation=landscape',
  },
  {
    slug: 'usfans-spreadsheet-vs-directory',
    prefix: 'a10',
    image:
      'https://readdy.ai/api/search-image?query=A%20split%20scene%20showing%20a%20spreadsheet%20grid%20on%20one%20side%20and%20a%20set%20of%20directory%20cards%20on%20the%20other%20divided%20by%20a%20thin%20line%20on%20a%20soft%20beige%20background%2C%20soft%20studio%20lighting%2C%20comparison%20concept%20graphic%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20balanced%20composition&width=800&height=450&seq=usfans-art-10&orientation=landscape',
  },
  {
    slug: 'usfans-beginner-handbook',
    prefix: 'a11',
    image:
      'https://readdy.ai/api/search-image?query=An%20open%20hardcover%20book%20with%20clean%20pages%20beside%20a%20folded%20sweater%20and%20a%20pair%20of%20sneakers%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20beginner%20guide%20and%20learning%20concept%20photography%2C%20editorial%20style%2C%20high%20detail%2C%20clean%20inviting%20composition&width=800&height=450&seq=usfans-art-11&orientation=landscape',
  },
];